



















































































import { Component, Vue } from 'vue-property-decorator';
import UpdateBankAccountChooseYourDocumentsViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-bank-account/update-bank-account-choose-your-documents-view-model';

@Component({ name: 'UpdateBankAccountChooseYourDocuments' })
export default class UpdateBankAccountChooseYourDocuments extends Vue {
  update_bank_choose_documents_view_model = Vue.observable(
    new UpdateBankAccountChooseYourDocumentsViewModel(this),
  );

  async mounted() {
    await this.update_bank_choose_documents_view_model.initialize();
  }
}
